import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
};

const EventPageContentContainer: React.FC<Props> = ({ children }) => {
    const theme = useTheme();

    const style = css`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 1050px;

        ${theme.breakpoints.up('3xl')} {
            margin-right: 20px;
        }

        ${theme.breakpoints.only('xxl')} {
            margin-left: 70px;
        }

        ${theme.breakpoints.only('xl')} {
            width: 1044px;
            margin-left: 54px;
        }

        ${theme.breakpoints.only('lg')} {
            width: 920px;
        }

        ${theme.breakpoints.down('md')} {
            width: 100%;
            justify-content: center;
        }
    `;

    return (
        <div css={style}>{children}</div>
    );
}

export default EventPageContentContainer;
